<template>
  <div :class="[b(), className]" :style="styleSizeName">
    <div class="fullScreen" :style="{'font-size': (option.fontSize || 18)  + 'px'}">
      <svg-icon
          :color="option.iconColor || '#e3f3ff'"
          icon-class="fullscreen-expand"
          v-show="!fullScreen"
          @click="fullScreenClick"
          class="screen-icon"
      />
      <svg-icon
          :color="option.iconColor || '#e3f3ff'"
          icon-class="fullscreen-shrink"
          v-show="fullScreen" @click="outFullScreenClick"
          class="screen-icon"
      />
    </div>
  </div>
</template>

<script>

import {fullscreenToggle} from "@/utils/utils";

export default {
  name: "FullScreen2",
  props: {},
  data() {
    return {
      fullScreen: false
    };
  },
  computed: {},
  watch: {},
  created() {
  },
  mounted() {
  },
  methods: {
    fullScreenClick() {
      this.fullScreen = true;
      fullscreenToggle();
    },
    outFullScreenClick() {
      this.fullScreen = false;
      fullscreenToggle();
    },
  },
};
</script>
<style lang="scss" scoped>
.fullScreen {
  font-size: 18px;
  color: #e3f3ff;
  z-index: 9999;
}

.screen-icon {
  cursor: pointer;
  //font-size: 18px;
}
</style>